import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import StatusPill from "@/components/leaves/StatusPill";

export default function MyLeavesTable({ items }) {
  return (
    <div className="overflow-hidden rounded-lg border border-[#e5e5e0] bg-white">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Type</TableHead>
            <TableHead>From</TableHead>
            <TableHead>To</TableHead>
            <TableHead>Reason</TableHead>
            <TableHead className="w-[120px]">Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((l) => (
            <TableRow key={l.id}>
              <TableCell className="capitalize">{l.leave_type}</TableCell>
              <TableCell className="font-mono text-xs">{l.start_date}</TableCell>
              <TableCell className="font-mono text-xs">{l.end_date}</TableCell>
              <TableCell className="text-sm text-[#575752]">{l.reason}</TableCell>
              <TableCell><StatusPill status={l.status} /></TableCell>
            </TableRow>
          ))}
          {items.length === 0 && (
            <TableRow>
              <TableCell colSpan={5} className="py-10 text-center text-sm text-[#575752]">
                No leaves yet.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
